<template>
    <div class="main">
      <h3 class="title">MRT技术支持及代理商联系信息（要购买MRT请通过以下方式联系我们）</h3>
      <div class="contact-text">
        <p>1. 华北地区代理及技术支持</p>
        <ul>
          <li>公司名称：北京华客博思科技有限公司</li>
          <li>联系人：黄华涛</li>
          <li>联系QQ号1：392430894
            <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=392430894&amp;site=qq&amp;menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:392430894:41" alt="点击这里给我发消息" title="点击这里给我发消息"></a>
          </li>
          <li>联系QQ号2：2392649707
            <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=2392649707&amp;site=qq&amp;menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:2392649707:41" alt="点击这里给我发消息" title="点击这里给我发消息"></a>
          </li>
          <li>华客博思技术支持QQ群：305178645，欢迎加入！</li>
          <li>联系电话：15811089836 ，010-82539930 ，400-065-1013</li>
          <li>公司网站：http://www.huakebosi.com      http://www.hkdatasos.cn</li>
          <li>地址：北京市海淀区中关村西区善缘街1号立方庭大厦9层1-921</li>
        </ul>
      </div>
      <div class="contact-text">
        <p>2. 华东地区代理及技术支持</p>
        <ul>
          <li>公司名称：南京西数科技</li>
          <li>联系人：陈兵兵</li>
          <li>联系QQ号1：276570401
            <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=276570401&amp;site=qq&amp;menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:276570401:41" alt="点击这里给我发消息" title="点击这里给我发消息"></a>
          </li>
          <li>联系QQ号2：569618827
            <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=569618827&amp;site=qq&amp;menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:569618827:41" alt="点击这里给我发消息" title="点击这里给我发消息"></a>
          </li>
          <li>西数科技技术支持QQ群：19018096，欢迎加入！</li>
          <li>联系电话：400-6184118，18651607829，13305156115，025-83608636</li>
          <li>公司网站：www.jsos.cn</li>
          <li>地址：南京市玄武区珠江路435号华海大厦606A室</li>
        </ul>
      </div>
      <div class="contact-text">
        <p> 3. 华南地区代理及技术支持</p>
        <ul>
          <li>公司名称：深圳市华强北维修网</li>
          <li>联系人：杨睿</li>
          <li>销售咨询QQ号1：326457071
            <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=326457071&amp;site=qq&amp;menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:326457071:41" alt="点击这里给我发消息" title="点击这里给我发消息"></a>
            电话：15915487905</li>
          <li>销售咨询QQ号2：411255792
            <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=411255792&amp;site=qq&amp;menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:411255792:41" alt="点击这里给我发消息" title="点击这里给我发消息"></a>
            电话：18929393685</li>
          <li>售后技术支持电话：18929393685</li>
          <li>电子邮件：326457071@qq.com</li>
          <li>地址：深圳市福田区深南中路佳和大厦B座15楼</li>
        </ul>
      </div>
      <div class="contact-text">
        <p > 4. 河南省代理及技术支持</p>
        <ul>
          <li>公司名称：河南开合软件技术有限公司</li>
          <li>联系人：王广峰</li>
          <li>联系电话：13592506985</li>
          <li> 地址：郑州市国家大学科技园东区16A 1302室</li>
        </ul>
      </div>
      <div class="contact-text">
        <p>5. 湖北地区代理及技术支持</p>
        <ul>
          <li>联系人：胡文俊</li>
          <li>联系QQ号1：2686785
            <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=2686785&amp;site=qq&amp;menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:2686785:41" alt="点击这里给我发消息" title="点击这里给我发消息"></a>
          </li>
          <li>联系QQ号2：139710407
            <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=139710407&amp;site=qq&amp;menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:139710407:41" alt="点击这里给我发消息" title="点击这里给我发消息"></a>
          </li>
          <li>星辉MRT数据恢复交流QQ群1：18299680，群2：4291654，欢迎加入！</li>
          <li>电话：13908648427 ，13607189189</li>
          <li>电子邮件：2686785@qq.com</li>
          <li>地址：武汉市江汉区前进电脑城1-88号 星辉电脑维修</li>
        </ul>
      </div>
      <div class="contact-text">
        <p>6. MRT固件实验室研发部</p>
        <ul>
          <li>地址：武汉市江岸区黄孝河路95号德盛大厦B座14楼03室</li>
          <li>联系人：陈顺学</li>
          <li>销售咨询QQ号1：3292109557
            <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=3292109557&amp;site=qq&amp;menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:3292109557:41" alt="点击这里给我发消息" title="点击这里给我发消息"></a>
            </li>
          <li>销售咨询QQ号2：480598561
            <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&amp;uin=480598561&amp;site=qq&amp;menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:480598561:41" alt="点击这里给我发消息" title="点击这里给我发消息"></a>
          </li>
          <li>MRT数据恢复交流QQ群1：14620648，群2：22539007</li>
          <li>QQ群3（VIP用户群）：239093202，欢迎加入！</li>
          <li>技术支持：需要联系MRT技术支持请<a href="https://vip.mrtlab.com/suptask.jsp" target="_blank"> 点击这里</a></li>
          <li>电话：027-82621261</li>
          <li>E-Mail：info@mrtlab.com ，sales@mrtlab.com</li>
        </ul>
      </div>
    </div>
</template>

<script>

  export default {
    name: "contactUs",
    data() {
      return {

      }
    },
    components:{},
    created: function () {

    },
    methods: {

    }
  }
</script>

<style scoped>
  .main {
    width: 1170px;
    padding:0px 15px;
    margin: 10px auto;
    min-height: calc(100% - 486px);
    background: #fff;
    border:#e5e5e5 1px solid;
    box-sizing: border-box;
  }
  .title {
    font-size: 20px;
  }
  .contact-text {
    margin-bottom: 30px;
  }
  .contact-text p{
    font-size: 18px;
    font-weight: bold;
    margin: 5px 0;
  }
  .contact-text ul li {
    font-size: 14px;
    line-height:200%;
  }

  .contact-text ul li a img {
    vertical-align: bottom;
    margin: 0 10px;
  }
  @media screen and (max-device-width: 1024px) {
     .main {
      width: 100%;
    }
    .title, .contact-text {
      padding: 0 15px;
    }
  }
  </style>



// WEBPACK FOOTER //
// src/components/contactUs.vue